export default "__VITE_ASSET__BDl9lmEf__"